<template>
  <div class="edit-more-effective">
    <PageHeader :title="baseInfo.title" />
    <div class="wrapper">
      <!-- 头部操作 -->
      <div class="top-edit-box" v-if="![7, 8, 9, 10].includes(reqCond.type)">
        <template v-if="isEdit">
          <van-button type="default" @click="cancel">取消</van-button>
          <van-button type="primary" color="#0082EF" @click="save">确定</van-button>
        </template>
        <template v-if="!isEdit">
          <van-button type="primary" color="#0082EF" @click="edit">{{
            reqCond.type === 5 ? "修改" : "新增"
          }}</van-button>
        </template>
      </div>
      <!-- 内容 -->
      <div class="form-box">
        <van-form scroll-to-error ref="formData">
          <!-- 其他标签1 西医诊断3 藏医诊断4 主诉症状6-->
          <template v-if="[1, 3, 4, 6].includes(reqCond.type)">
            <div class="select-box" v-if="isEdit">
              <vSelect v-if="reqCond.type !== 3" :options="selectList" :reduce="(item) => item.value" label="value"
                :multiple="false" :taggable="reqCond.type !== 4" :clearable="false" :pushTags="reqCond.type !== 4"
                :selectable="(option) => !option.disabled" v-model="addEditData.name" @option:selected="changeSelected">
                <template #open-indicator="{ attributes }">
                  <span v-bind="attributes">
                    <van-icon name="play" class="icon-box" />
                  </span>
                </template>
                <template #no-options>无匹配数据</template>
              </vSelect>
              <vSelect v-else :options="selectList" :reduce="(item) => item.icdName" label="icdName" :multiple="false"
                :clearable="false" taggable v-model="addEditData.name" :selectable="(option) => !option.disabled"
                @search="fetchOptions" @option:selected="changeSelected">
                <template #open-indicator="{ attributes }">
                  <span v-bind="attributes">
                    <van-icon name="play" class="icon-box" />
                  </span>
                </template>
                <template #no-options>无匹配数据</template>
              </vSelect>
            </div>
            <template v-if="reqCond.type === 6 && isEdit">
              <div class="form-item-box">
                <div class="form-item-title">持续时间：</div>
                <div class="form-item-item" @click="showPopupClick">
                  <div class="calendar-box van-hairline--surround">
                    {{
                      (Array.isArray(addEditData.startEndTime) &&
                        `${addEditData.startEndTime[0]} - ${addEditData.startEndTime[1]}`) ||
                      "请选择"
                    }}
                  </div>
                </div>
              </div>
              <div class="form-item-box">
                <div class="form-item-title">备注</div>
                <div class="form-item-item van-hairline--surround">
                  <van-field v-model="addEditData.remark" rows="2" autosize label="" type="textarea" maxlength="200"
                    placeholder="请输入备注" show-word-limit />
                </div>
              </div>
            </template>
            <BaseAddTag show-close :tagList="tagList" @removeTag="removeTag" />
          </template>
          <!-- 病种分类 -->
          <template v-else-if="reqCond.type === 2">
            <div class="box-two" v-if="isEdit">
              <div class="box-two-item van-ellipsis" v-for="(item, index) in selectList" :key="index" :class="{
                'box-two-item-active': addEditData.name === item.value,
                'box-two-item-disable': isDisable(item.value),
              }" @click="!isDisable(item.value) && typeItemClick(item.value)">
                {{ item.value }}
              </div>
            </div>
            <div style="margin-top: 20px">
              <BaseAddTag show-close :tag-list="tagList" @removeTag="removeTag" />
            </div>
          </template>
          <template v-else-if="reqCond.type === 5">
            <div class="box-five van-hairline--surround">
              <van-field v-model="addEditData.illnessSyntheticDes" rows="6" autosize label="" type="textarea"
                maxlength="200" placeholder="请输入综述" show-word-limit />
            </div>
          </template>
          <template v-else-if="[7, 8, 9, 10].includes(reqCond.type)">
            <template v-if="reqCond.type !== 10">
              <div class="form-item-box">
                <div class="form-item-title">持续时间：</div>
                <div class="form-item-item" @click="showPopupClick">
                  <div class="calendar-box van-hairline--surround">
                    {{
                      (Array.isArray(addEditData.startEndTime) &&
                        `${addEditData.startEndTime[0]} - ${addEditData.startEndTime[1]}`) ||
                      "请选择"
                    }}
                  </div>
                </div>
              </div>
              <div class="form-item-box">
                <div class="form-item-title">{{ baseInfo.infoTitle }}</div>
                <div class="form-item-item" style="width: 100%">
                  <vSelect :options="selectList" :reduce="(item) => item.value" label="value" :multiple="false" taggable
                    :clearable="false" pushTags v-model="addEditData.name" @option:selected="changeSelected">
                    <template #open-indicator="{ attributes }">
                      <span v-bind="attributes">
                        <van-icon name="play" class="icon-box" />
                      </span>
                    </template>
                    <template #no-options>无匹配数据</template>
                  </vSelect>
                </div>
              </div>
              <div class="form-item-box">
                <div class="form-item-title">备注</div>
                <div class="form-item-item van-hairline--surround">
                  <van-field v-model="addEditData.remark" rows="1" autosize label="" type="textarea" maxlength="200"
                    placeholder="请输入" />
                </div>
              </div>
            </template>
            <template v-else>
              <div class="form-item-box">
                <van-radio-group v-model="addEditData.type" direction="horizontal">
                  <van-radio :name="item.key" icon-size="14px" v-for="item in radioList" :key="item.key">
                    {{ item.value }}
                  </van-radio>
                </van-radio-group>
              </div>
              <div class="form-item-box">
                <div class="form-item-title">
                  {{ addEditData.type === 5 ? "续药日期" : "停药日期" }}
                </div>
                <div class="form-item-item" @click="showPopupClick">
                  <div class="calendar-box van-hairline--surround">
                    {{
                      (addEditData.startEndTime &&
                        addEditData.startEndTime[0]) ||
                      "请选择"
                    }}
                  </div>
                </div>
              </div>
              <div class="form-item-box">
                <div class="form-item-title">
                  {{ addEditData.type === 5 ? "续药原因" : "停药原因" }}
                </div>
                <div class="form-item-item van-hairline--surround">
                  <van-field v-model="addEditData.remark" rows="1" autosize label="" type="textarea" maxlength="200"
                    placeholder="请输入" />
                </div>
              </div>
              <div class="form-item-box">
                <div class="form-item-title">
                  {{
                    `${addEditData.type === 5 ? "续药" : "停药"}时实际${addEditData.type === 5 ? "停止天数" : "服药疗程数"
                      }`
                  }}
                </div>
                <div class="form-item-item form-no-padding van-hairline--surround"
                  style="width: 54px; display: inline-block">
                  <van-field class="my-input" v-model="addEditData.stopNum" label="" type="digit" maxlength="6" />
                </div>
                <span>
                  {{ addEditData.type === 5 ? "天" : "疗程" }}
                </span>
              </div>
            </template>
            <div class="top-edit-box top-edit-bottom">
              <van-button type="primary" color="#EC716F" @click="remove" v-if="addEditData.id">删除</van-button>
              <van-button type="primary" color="#0082EF" @click="save"
                :class="addEditData.id ? '' : 'max-button'">确定</van-button>
            </div>
          </template>
          <template v-else></template>
        </van-form>
      </div>
      <div class="safe-area-inset-bottom"></div>
    </div>
    <div class="bottom-box safe-area-inset-bottom">
      <div class="bottom-container">
        <van-button type="primary" block @click="goBack" class="button-box">返回上级页面</van-button>
      </div>
    </div>
    <van-calendar v-model="showPopup" :min-date="new Date('2018-01-01')" :max-date="new Date('2050-01-01')"
      @confirm="onConfirm" :default-date="defaultDate" :type="[6, 7, 8, 9].includes(reqCond.type) ? 'range' : 'single'"
      :close-on-click-overlay="false" color="#0082EF" />
  </div>
</template>
<script>
import PageHeader from "@/components/PageHeader/index.vue";
import BaseAddTag from "./components/baseAddTag.vue";
import {
  getUserInfo,
  getDictionaryList,
  delectTag,
  addTag,
  getSymptomlist,
  removePatient,
  addPatient,
  getWesternList,
  changeDescription,
  getPatient,
  removeSymptomsOfIllness,
  updateSymptomsOfIllness,
  addSymptomsOfIllness,
} from "@/api/moreEffective";
import { debounce, timeFormat } from "@/utils/baseFormat";
import { Dialog } from "vant";
import { Toast } from "vant";
export default {
  name: "editMoreEffective",
  components: {
    PageHeader,
    BaseAddTag,
  },
  data() {
    return {
      isEdit: false,
      addEditData: {},
      reqCond: {
        userMemberId: null,
        type: 1, // 1 其他标签 2 病种分类 3 西医诊断 4 藏医诊断 5 病情描述 6 主诉症状 7 暝眩反应 8 入药反应 9 新发症状 10 停续药安排
        isUpDate: false,
      },
      userInfo: {},
      selectList: [],
      tagList: [],
      showPopup: false,
    };
  },
  created() {
    const { type, id } = this.$route.query;
    console.log(this.$route.params);
    this.reqCond = {
      type: typeof type === "undefined" ? "" : type * 1,
      userMemberId: id * 1,
      isUpDate: false,
    };
    this.init();
  },
  methods: {
    changeSelected(e) {
      console.log(e);
      let result =
        Object.prototype.toString.call(e) === "[object Object]"
          ? this.reqCond.type === 3
            ? e.icdName
            : e.value
          : e;
      this.$set(this.addEditData, "name", result);
    },
    goBack() {
      if (this.reqCond.isUpDate) {
        this.$router.replace({
          name: "MoreEffective",
          query: {
            id: this.reqCond.userMemberId,
          },
          params: {
            isUpDate: true,
          },
        });
      } else {
        this.$router.back();
      }
    },
    cancel() {
      this.isEdit = false;
      this.addEditData = {};
    },
    remove() {
      this.removeDialog(this.addEditData.id);
    },
    async save() {
      console.log(this.addEditData);
      if ([1, 3, 4, 6].includes(this.reqCond.type)) {
        if (!this.addEditData.name) return Toast("请选择或者输入");
        if (!this.addEditData.startEndTime && this.reqCond.type === 6)
          return Toast("请选择时间");
      }
      if (this.reqCond.type >= 7) {
        if (!this.addEditData.startEndTime) return Toast("请选择时间");
      }
      let params = {
        ...this.addEditData,
        type: this.reqCond.type - 1,
        userMemberId: this.reqCond.userMemberId,
      };
      if (this.reqCond.type === 6) {
        params = {
          ...params,
          startTime: params.startEndTime[0],
          endTime: params.startEndTime[1],
          startEndTime: "",
          type: this.reqCond.type - 2,
        };
      }
      if (this.reqCond.type >= 7) {
        params = {
          ...params,
          startTime: params.startEndTime[0],
          endTime: params.startEndTime[1],
          startEndTime: "",
          type: this.addEditData.type,
        };
      }
      // 1 其他标签 2 病种分类 3 西医诊断 4 藏医诊断 5 主诉症状
      const findObj = this.selectList.find(
        (item) =>
          item[this.reqCond.type === 3 ? "icdName" : "value"] ===
          this.addEditData.name
      );
      params = {
        ...params,
        code:
          this.addEditData.code || findObj
            ? findObj[this.reqCond.type === 3 ? "id" : "key"]
            : "",
      };

      try {
        if (this.reqCond.type >= 7) {
          this.addEditData.id
            ? await updateSymptomsOfIllness(params)
            : await addSymptomsOfIllness(params);
        } else {
          await this.baseInfo.addSelect(params);
        }
      } catch (error) {
        console.log(error);
      }
      Toast(`${this.addEditData.id ? "修改" : "添加"}成功`);
      this.updatePage();
      this.cancel();
    },
    async edit() {
      this.reqCond.type !== 5 && this.reqCond.type !== 10 && this.getData();
      this.isEdit = true;
    },
    async getData(params) {
      try {
        const { data } = await this.baseInfo.getSelectList(params);
        if ([6, 7, 8, 9].includes(this.reqCond.type)) {
          this.selectList = data.map((item) => ({
            key: item.value,
            value: item.text,
            disabled: this.tagList.some((It) => {
              return It.code === item.value;
            }),
          }));
        } else if (this.reqCond.type === 3) {
          this.selectList = this.formatList(data.list);
        } else {
          this.selectList = data.list.map((item) => {
            return {
              ...item,
              disabled: this.tagList.some((It) => It.name === item.value),
            };
          });
        }
        this.$forceUpdate();
      } catch (error) {
        console.log(error);
      }
    },
    removeTag(id) {
      // 删除标签
      this.removeDialog(id);
    },
    removeDialog(id) {
      console.log(id);
      Dialog.confirm({
        title: "",
        message: "是否确认删除？ 删除后数据将不可恢复。",
        className: "my-close-dialog",
      })
        .then(async () => {
          try {
            await this.baseInfo.delete(id);
            // 更新
            this.updatePage();
            Toast("删除成功");
            this.cancel();
          } catch (error) {
            console.log(error);
          }
        })
        .catch(() => {
          // on cancel
          console.log("取消删除");
        });
    },
    updatePage() {
      // 更新
      this.reqCond.isUpDate = true;
      switch (this.reqCond.type) {
        case 1:
        case 5:
          this.getPageInfo();
          break;
        case 2:
        case 3:
        case 4:
        case 6:
          this.getPatientInfo();
          break;
        default:
          this.goBack();
      }
    },
    // 数据相关
    init() {
      //用户数据
      console.log(this.reqCond.type);
      switch (this.reqCond.type) {
        case 1:
        case 5:
          this.getPageInfo();
          break;
        case 2:
        case 3:
        case 4:
        case 6:
          this.getPatientInfo();
          break;
        default:
          this.addEditData = { ...this.$route.params };
          this.reqCond.type !== 10 && this.getData();
      }
    },
    async getPageInfo() {
      try {
        const { data } = await getUserInfo({
          id: this.reqCond.userMemberId,
        });
        this.userInfo = { illnessSyntheticDes: data.illnessSyntheticDes };
        this.addEditData = { illnessSyntheticDes: data.illnessSyntheticDes };
        this.tagList = (data.tagList || []).map((item) => ({
          id: item.value,
          name: item.text,
        }));
      } catch (error) {
        this.$set(this.addEditData, "name", "");
        this.tagList = [];
        console.log(error);
      }
    },
    // 患者病情详情
    async getPatientInfo() {
      try {
        this.tagList = [];
        const { data } = await getPatient(this.reqCond.userMemberId);
        JSON.parse(JSON.stringify(data.diseaseList || [])).forEach((item) => {
          const obj = {
            2: 1, //病种分类
            3: 2, //西医诊断
            4: 3, //藏医诊断
            6: 4, //主诉症状
          };
          if (item.type === obj[this.reqCond.type]) {
            this.tagList = [...this.tagList, item];
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    // 处理数据
    formatList(list = []) {
      const cloneList = JSON.parse(JSON.stringify(list));
      return cloneList.map((item) => {
        return {
          ...item,
          disabled: this.tagList.some((It) => It.name === item.icdName),
        };
      });
    },
    //
    typeItemClick(name) {
      this.$set(this.addEditData, "name", name);
    },
    isDisable(name) {
      return this.tagList.some((it) => it.name === name);
    },
    fetchOptions(name) {
      if (!name) return;
      const params = {
        pageNum: 1,
        pageSize: 20,
        icdName: name,
      };
      debounce(() => {
        this.getData(params);
      }, 800);
    },
    showPopupClick() {
      this.showPopup = true;
    },
    closePopupClick() {
      this.showPopup = false;
    },
    onConfirm(e) {
      console.log(e);
      if (Array.isArray(e)) {
        const start = timeFormat(e[0], "yyyy-mm-dd");
        const end = timeFormat(e[1], "yyyy-mm-dd");
        this.$set(this.addEditData, "startEndTime", [start, end]);
        this.showPopup = false;
      } else {
        const result = timeFormat(e, "yyyy-mm-dd");
        this.$set(this.addEditData, "startEndTime", [result]);
        this.showPopup = false;
      }
    },
  },
  computed: {
    baseInfo() {
      return (
        {
          1: {
            title: "修改其他标签",
            delete: (id) => delectTag(id),
            getSelectList: () =>
              getDictionaryList({
                typeCode: "MEMBER_TAG_TYPE",
              }),
            addSelect: (data) => addTag({ ...data, tag: data.name }),
          },
          2: {
            title: "修改病种分类",
            getSelectList: () =>
              getDictionaryList({
                typeCode: "DISEASE_TYPE",
              }),
            delete: (id) => removePatient(id),
            addSelect: (data) => addPatient(data),
          },
          3: {
            title: "修改西医诊断",
            getSelectList: (
              data = {
                pageNum: 1,
                pageSize: 20,
              }
            ) => getWesternList(data),
            delete: (id) => removePatient(id),
            addSelect: (data) => addPatient(data),
          },
          4: {
            title: "修改藏医诊断",
            getSelectList: () =>
              getDictionaryList({
                typeCode: "TIBETAN_MEDICINE_ASK",
              }),
            delete: (id) => removePatient(id),
            addSelect: (data) => addPatient(data),
          },
          5: {
            title: "修改病情描述",
            addSelect: (data) => changeDescription(data),
          },
          6: {
            title: "修改主诉症状",
            getSelectList: () => getSymptomlist({ type: 0 }),
            delete: (id) => removePatient(id),
            addSelect: (data) => addPatient(data),
          },
          7: {
            title: `${this.addEditData.id ? "修改" : "新增"}暝眩反应`,
            infoTitle: "瞑眩症状",
            getSelectList: () => getSymptomlist({ type: 1 }),
            delete: (id) => removeSymptomsOfIllness(id),
          },
          8: {
            title: `${this.addEditData.id ? "修改" : "新增"}入药反应`,
            infoTitle: "反应症状",
            getSelectList: () => getSymptomlist({ type: 2 }),
            delete: (id) => removeSymptomsOfIllness(id),
          },
          9: {
            title: `${this.addEditData.id ? "修改" : "新增"}新发症状`,
            infoTitle: "症状描述",
            getSelectList: () => getSymptomlist({ type: 3 }),
            delete: (id) => removeSymptomsOfIllness(id),
          },
          10: {
            title: `${this.addEditData.id ? "修改" : "新增"}停续药安排`,
            delete: (id) => removeSymptomsOfIllness(id),
          },
        }[this.reqCond.type] || {}
      );
    },
    defaultDate() {
      let endTime = new Date().setTime(
        new Date().getTime + 1000 * 60 * 60 * 12
      );
      return [6, 7, 8, 9].includes(this.reqCond.type)
        ? Array.isArray(this.addEditData.startEndTime)
          ? [
            new Date(this.addEditData.startEndTime[0]),
            new Date(this.addEditData.startEndTime[1]),
          ]
          : [new Date(), endTime]
        : this.addEditData.startEndTime
          ? new Date(this.addEditData.startEndTime)
          : new Date();
    },
    radioList() {
      return [
        { key: 4, value: "停药安排" },
        { key: 5, value: "续药安排" },
      ];
    },
  },
};
</script>
<style scoped lang="scss">
.safe-area-inset-bottom {
  padding-bottom: constant(safe-area-inset-bottom) !important;
  padding-bottom: env(safe-area-inset-bottom) !important;
}

:deep(textarea) {
  font-size: 14px;
}

:deep(.my-input) {
  input {
    text-align: center;
    font-size: 14px;
  }
}

:deep(.v-select) {
  width: 100%;

  .vs__dropdown-menu {
    * {
      font-size: 16px !important;
    }
  }

  .vs__dropdown-option {
    font-size: 16px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 100%;
    box-sizing: border-box;
  }

  .vs__selected,
  .vs__selected-options {
    font-size: 16px;
  }

  input {
    font-size: 16px;
  }

  .icon-box {
    transform: rotate(90deg);
    color: #999999;
    font-size: 12px;
  }

  // .vs__dropdown-option {
  //   color: #333333;

  //   &:hover,
  //   .vs__dropdown-option--selected {
  //     background: #f5f5f5;
  //     color: #333333;
  //   }
  // }

  // .vs__dropdown-option--highlight {
  //   background: #f5f5f5;
  //   color: #333333;
  // }
}

:deep(.van-radio) {
  .van-radio__label {
    font-size: 14px;
    color: #888888;
    margin-left: 5px;
  }

  .van-radio__icon--checked {
    .van-icon {
      border: 1px solid #4991fc;
      background-color: #fff;
      position: relative;

      &::before {
        position: absolute;
        content: "";
        left: 50%;
        top: 50%;
        width: 75%;
        height: 75%;
        border-radius: 50%;
        background: #4991fc;
        transform: translate(-50%, -50%);
      }
    }
  }
}

.edit-more-effective {
  padding: 0 10px 80px;
  box-sizing: border-box;

  .wrapper {
    background: #ffffff;
    min-height: calc(100vh - 135px);
    box-sizing: border-box;
    margin-bottom: 8px;
    padding: 20px;

    .top-edit-box {
      justify-content: flex-end;
      display: flex;

      :deep(.van-button) {
        font-size: 14px;
        border-radius: 4px;
        padding: 6px 20px;
        width: auto;
        height: auto;

        &+.van-button {
          margin-left: 20px;
        }
      }
    }

    .top-edit-bottom {
      justify-content: center;
      margin-top: 30px;

      .max-button {
        padding: 5px 62px;
      }
    }

    .form-box {
      margin-top: 18px;

      .form-item-box {
        margin-bottom: 10px;

        .form-item-title {
          font-size: 16px;
          padding-bottom: 10px;
          color: #333333;
        }

        span {
          font-size: 14px;
          color: #333333;
          margin-left: 5px;
        }

        .form-item-item {
          font-size: 16px;
          border-radius: 4px;
          display: flex;

          &::after {
            border-radius: 4px;
          }

          .calendar-box {
            padding: 6px 24px 6px 29px;
            position: relative;
            border-radius: 4px;
            font-size: 14px;
            color: #333333;

            &::after {
              border-radius: 4px;
            }

            &::before {
              content: "";
              position: absolute;
              left: 10px;
              top: 50%;
              transform: translateY(-50%);
              background: url("~@/assets/images/moreEffective/calendar.png") center/cover no-repeat;
              width: 14px;
              height: 14px;
            }
          }

          .van-cell {
            padding: 12px;
          }
        }

        .form-no-padding {
          .van-cell {
            padding: 2px;
          }
        }
      }

      .select-box {
        height: 32px;
        margin-bottom: 20px;
      }
    }

    .box-two {
      margin-top: 20px;
      padding: 15px;
      padding-bottom: 0;
      border: 1px solid #e1e8ef;
      border-radius: 4px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .box-two-item {
        font-size: 16px;
        color: #333333;
        border-radius: 4px;
        border: 1px solid #333333;
        background: #ffffff;
        width: 30%;
        text-align: center;
        padding: 8px 0;
        margin-bottom: 15px;
      }

      .box-two-item-disable {
        border-color: #cfcfcf;
        color: #cfcfcf;
        cursor: not-allowed;
      }

      .box-two-item-active {
        border-color: #0082ef;
        color: #0082ef;
        background: #eff3fb;
      }
    }

    :deep(.box-five) {
      border-radius: 4px;

      &::after {
        border-radius: 4px;
      }

      .van-cell {
        padding: 12px;

        .van-field__word-limit {
          font-size: 13px;
          color: #999999;
        }
      }
    }
  }

  .bottom-box {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    border-radius: 0px 0px 0px 0px;
    z-index: 10;
    background: #ffffff;

    .bottom-container {
      height: 84px;
      background: #ffffff;
      box-sizing: border-box;
      padding: 16px 25px;

      .button-box {
        background: #0082ef;
        font-size: 20px;
        font-weight: bold;
        color: #ffffff;
        border: none;
        border-radius: 8px;
      }
    }
  }
}
</style>
<style lang="scss">
.my-close-dialog {
  .van-dialog__message {
    font-size: 15px;
    color: #333333;
  }

  .van-dialog__footer {
    .van-button {
      font-size: 15px;
      font-weight: bold;
      color: #333333;

      &+.van-button {
        color: #0082ef;
      }
    }
  }
}
</style>
